import * as React from 'react'
import STAGES from 'app/stage'
import {
  preventBack,
  preventRightClick
} from 'app/service/util'
import * as Sound from 'app/service/sound'
import * as Event from 'app/service/event'


export default class App extends React.Component<{}, {
  time: number
  stage: number
}> {

  constructor(props) {
    super(props)

    let stage = 0

    if (document.location.hash.startsWith('#dev/')) {
      stage = parseInt(document.location.hash.slice(5))
    }

    this.state = {
      time: 0,
      stage,
    }

    setInterval(() => {
      if (this.state.stage == 0 || this.state.stage == STAGES.length - 1) {
        return
      }
      this.setState({
        time: this.state.time + 1000
      })
    }, 1000)

    preventBack(`Are you sure you want to leave? You will lose your progress.`)
    preventRightClick()
  }

  componentDidMount() {
    Event.track('viewed_home')
  }

  nextStage = () => {
    const { stage } = this.state

    history.pushState(null, document.title, location.href)

    if (stage == STAGES.length - 1) {
      this.setState({stage: 0})
    } else {
      const nextStage = stage + 1
      Sound.playRiff(stage)
      this.setState({stage: nextStage})
      Event.track(`viewed_stage_${nextStage}`)
    }
  }

  reset = () => {
    this.setState({stage: 0, time: 0})
  }

  addTime = (duration: number) => {
    Event.track('added_time')
    this.setState({time: this.state.time + duration})
  }

  renderStage() {
    const {
      stage,
      time
    } = this.state

    const stageComp = STAGES[stage]

    return React.createElement(stageComp, {
      time: time,
      onNext: this.nextStage,
      stageInfo: {
        current: stage,
        total: STAGES.length - 2
      },
      onAddTime: this.addTime
    })
  }

  render() {
    const {
    } = this.state

    return (
      <div>
        {this.renderStage()}
      </div>
    )

  }

}


// WEBPACK FOOTER //
// ./src/comp/app.tsx